import React, { useEffect, useState } from 'react';

export default function SelectControl({ value, change, label = '', help = '', valid = true, options = [], classlist = '', disabled = false, required = false }) {
  return (
    <div className={`text-control ${classlist}`}>
      {label && <label className='form-label'>{label} {required && <span className='required'>*</span>}</label>}
      <select disabled={disabled ? 'disabled' : ''} className={`${valid && 'valid'}`} value={value} onChange={(e) => { change(e.target.value) }}>
        {options.length > 0 && options.map((opt) =>
          <option value={opt.value}>{opt.label}</option>
        )}
      </select>
      {help && <div className='form-help'>{help}</div>}
    </div>
  )
}
